import { useEffect } from 'react';
import { useForm } from 'hooks/useForm';
import { getCashboxSchema } from 'constants/formValidationSchemas/cashboxSchema';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { Modal } from 'components/Modal';
import styles from '../Cashboxes.scss';

export const AccountForm = ({
  isOpen,
  setIsOpen,
  title,
  initialValues,
  onSubmit,
  submitText,
  balanceLabel,
  balancePlaceholder,
  hideBalanceField = false,
}) => {
  const handleCreateClose = () => {
    setIsOpen(false);
    resetForm();
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm, isValid } =
    useForm({
      initialValues,
      validationSchema: getCashboxSchema(hideBalanceField),
      onSubmit,
      trimValues: true,
      status: {},
    });

  useEffect(() => {
    if (initialValues) {
      setFieldValue('name', initialValues.name);
      setFieldValue('balance', initialValues.balance);
      setFieldValue('method', initialValues.method);
    }
  }, [initialValues]);

  const handleChangeMethod = (e) => {
    const value = e.target.value;
    const newMethod = hideBalanceField ? { id: values.method.id, label: value } : value;
    setFieldValue('method', newMethod);
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={handleCreateClose}>
      <h3>{title}</h3>

      <form onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label>Повна назва рахунку:</label>
          <Input
            type='text'
            name='name'
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder='Введіть назву рахунку'
            invalid={touched.name && errors.name}
            errorText={touched.name && errors.name}
          />
        </div>

        <div className={styles.formGroup}>
          <label>Коротка назва:</label>
          <Input
            type='text'
            name='method'
            value={hideBalanceField ? values.method?.label || '' : values.method || ''}
            onChange={handleChangeMethod}
            onBlur={handleBlur}
            placeholder='Введіть коротку форму назви'
            invalid={touched.method && errors.method?.label}
            errorText={touched.method && errors.method?.label}
          />
        </div>

        {!hideBalanceField && (
          <div className={styles.formGroup}>
            <label>{balanceLabel}:</label>
            <Input
              type='number'
              min='0'
              name='balance'
              value={values.balance}
              onChange={handleChange}
              onBlur={handleBlur}
              placeholder={balancePlaceholder}
              invalid={touched.balance && errors.balance}
              errorText={touched.balance && errors.balance}
            />
          </div>
        )}

        <div className={styles.modalActions}>
          <Button className={styles.modalBtn} type='button' onClick={handleCreateClose} ghostStyle smallStyle>
            Скасувати
          </Button>
          <Button className={styles.modalBtn} type='submit' disabled={!isValid} smallStyle>
            {submitText}
          </Button>
        </div>
      </form>
    </Modal>
  );
};
